import type { ApiModuleEndpoints } from '../types'
export const activityLogApiEndpoints = {
  list: { method: 'GET', path: '/activity-logs' },
  filters: { method: 'GET', path: '/activity-logs/filters' },
  detail: { method: 'GET', path: '/activity-logs/:id' },
} as const satisfies ApiModuleEndpoints
